// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2nb8s","overflowing":"ReadFullNote_overflowing__2hMlD"};